import { useRoomSettings } from "../../context";
import PinnedGrid from "./PinnedGrid";
import EvenGrid from "./EvenGrid";
import { MediaParticipant } from "@dvrt/web-phone-client";

const ParticipantGrid = ({ participants }: { participants: MediaParticipant[] }) => {
    const { pinnedParticipants } = useRoomSettings();

    const sortedParticipants = participants.sort((a, b) => a.name.localeCompare(b.name)).concat();

    return Object.keys(pinnedParticipants).length ? (
        <PinnedGrid participants={sortedParticipants} />
    ) : (
        <EvenGrid participants={sortedParticipants} />
    );
};

export default ParticipantGrid;
